import { createFileRoute } from '@tanstack/react-router';

import { NegotiationDemandGroupAwardingPage } from '@/areas/negotiations/Negotiations/NegotiationDemandGroupPage/NegotiationDemandGroupPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding',
)({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <NegotiationDemandGroupAwardingPage
            negotiationId={pathParams.negotiationId}
            demandGroupId={pathParams.demandGroupId}
        />
    );
}
